var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTableAction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 12,
    fill: "#363636"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5816 10.9999L28.4184 10.9999C29.0831 10.999 29.7344 11.1862 30.2971 11.5401C30.8598 11.894 31.3107 12.4 31.5977 12.9995C31.9337 13.7109 32.0632 14.5023 31.9712 15.2836C31.8793 16.0649 31.5698 16.8047 31.0778 17.4187L22.6595 27.6167C22.3291 27.9979 21.9207 28.3036 21.4618 28.5131C21.003 28.7226 20.5044 28.8311 20 28.8311C19.4956 28.8311 18.997 28.7226 18.5382 28.5131C18.0793 28.3036 17.6709 27.9979 17.3405 27.6167L8.92216 17.4187C8.43024 16.8047 8.12068 16.0649 8.02876 15.2836C7.93685 14.5023 8.06626 13.7109 8.40226 12.9995C8.68929 12.4 9.14023 11.894 9.7029 11.5401C10.2656 11.1862 10.9169 10.9989 11.5816 10.9999Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableAction);
export default __webpack_public_path__ + "static/media/table-action.9329e22e86f2d097ceeeaced66e482b0.svg";
export { ForwardRef as ReactComponent };